const FEATURES = {
    ALL: 'all',
    TEAM_MANAGEMENT: 'teamManagement',
    SAVE_TO_CRM: 'saveToCrm',
    BULK_ENRICH: 'bulkEnrich',
    PROSPECTING: 'prospecting',
    SAVE_TO_SALESFORCE: 'saveToSalesforce',
    SAVE_TO_HUBSPOT: 'saveToHubspot',
    SAVE_TO_OUTREACH: 'saveToOutreach',
    SAVE_TO_PIPEDRIVE: 'saveToPipedrive',
    SAVE_TO_SALESLOFT: 'saveToSalesloft',
    SAVE_TO_ZOHO: 'saveToZoho',
    SAVE_TO_BULLHORN: 'saveToBullhorn',
    SAVE_TO_DYNAMICS: 'saveToDynamics',
    SHOW_SPECIFIC_DATA_POINTS: 'showSpecificDataPoints',
    ONE_WALLET: 'oneWallet',
    SCALE_FREE_TRIAL: 'scaleFreeTrial',
};
export default FEATURES;
